import { createSelector } from 'reselect';

import type { RootState } from '../store/store';

const selectScribe = (state: RootState) => state.scribe;

export const selectSpeakerListened = createSelector([selectScribe], (scribe) => scribe.speakerListened);

export const selectScribeInURL = createSelector([selectScribe], (scribe) => scribe.scribeInURL);
